'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getBillingUserCount(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/billing/usercount`
        const result = await axios.post(url, body, {
          ...costumHeader('Get Billing User Count', 4)
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', { type: 'warning', msg: result.data.message })
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', { type: 'error', msg: e.message })
        return resolve([])
      }
    })
  },
  getBillingList(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/billing/list`
        const result = await axios.post(url, body, {
          ...costumHeader('Get Billing List', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', { type: 'warning', msg: result.data.message })
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', { type: 'error', msg: e.message })
        return resolve([])
      }
    })
  },
  saveBilling(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/billing/insert`
        const headers = { headers: { 'Content-Type': 'multipart/form-data', action: 'Add Billing', actionId: 1 } }
        const result = await axios.post(url, body, headers)
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', { type: 'warning', msg: result.data.message })
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', { type: 'error', msg: e.message })
        return resolve(false)
      }
    })
  },
  editBilling(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/billing/update`
        const headers = { headers: { 'Content-Type': 'multipart/form-data', action: 'Edit Billing', actionId: 2 } }
        const result = await axios.post(url, body, headers)
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', { type: 'warning', msg: result.data.message })
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', { type: 'error', msg: e.message })
        return resolve(false)
      }
    })
  },
  deleteBilling(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/billing/delete`
        const result = await axios.post(url, body, costumHeader('Delete Billing', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', { type: 'warning', msg: result.data.message })
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', { type: 'error', msg: e.message })
        return resolve(false)
      }
    })
  },
}

export default { actions }